__turbopack_context__.v({
  "hiddenPlaceholder": "visitor-theme-switcher-control-module__F5Lxoq__hiddenPlaceholder",
  "iconButton": "visitor-theme-switcher-control-module__F5Lxoq__iconButton",
  "root": "visitor-theme-switcher-control-module__F5Lxoq__root",
  "segment": "visitor-theme-switcher-control-module__F5Lxoq__segment",
  "segmentActive": "visitor-theme-switcher-control-module__F5Lxoq__segmentActive",
  "segmentLabel": "visitor-theme-switcher-control-module__F5Lxoq__segmentLabel",
  "segmented": "visitor-theme-switcher-control-module__F5Lxoq__segmented",
  "sizeLg": "visitor-theme-switcher-control-module__F5Lxoq__sizeLg",
  "sizeMd": "visitor-theme-switcher-control-module__F5Lxoq__sizeMd",
  "sizeSm": "visitor-theme-switcher-control-module__F5Lxoq__sizeSm",
});
